import { useFormikContext } from "formik"
import { makeStyles } from "tss-react/mui"
import { faCartShopping, faXmark } from "@fortawesome/pro-solid-svg-icons"
import { LocalizedStrict } from "../../../../../../modules/localization/components/AppLocalized"
import { DeliveryTimesField, DynamicConfigKey, MeetingServiceTabValues } from "../../form/formTypes"
import { OrderSummaryContent } from "./OrderSummary"
import { AccordionSection } from "../AccordionSection"
import { CreateOrderType } from "../../../helpers"
import { CreateOrderDialogMode } from "../../../createOrderTypes"
import { IconBadge } from "../../../../badges/IconBadge"
import { IconButton, Stack, Typography } from "@mui/material"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

const useStyles = makeStyles()((theme) => ({
    title: {
        color: theme.palette.text.primary,
    },
    closeButton: {
        color: theme.palette.tailwind.slate[500],
        transition: "all ease-in-out 0.3s",
        padding: 0,
        "&:hover": {
            background: "none",
            color: theme.palette.text.primary,
        },
    },
}))

type OrderSummaryWrapProps = Readonly<{
    isRefundOrder: boolean
    handleCloseDrawer?: () => void
    isUpdatable?: boolean
    orderType: CreateOrderType
    userId: number
    mode?: CreateOrderDialogMode
}>

export function OrderSummaryWrap({
    isRefundOrder,
    handleCloseDrawer,
    isUpdatable = false,
    orderType,
    userId,
    mode,
}: OrderSummaryWrapProps) {
    const { classes } = useStyles()

    return (
        <>
            <Stack gap="2rem">
                <Stack flexDirection="row" gap="1rem" justifyContent="space-between" alignItems="center">
                    <Stack flexDirection="row" gap=".75rem" alignItems="center">
                        <IconBadge variant="font-awesome" color="blue" fontAwesomeIcon={faCartShopping} />
                        <LocalizedStrict id="create-order-order-summary">
                            <Typography variant="h6" className={classes.title}>
                                Order summary
                            </Typography>
                        </LocalizedStrict>
                    </Stack>
                    {!isRefundOrder && (
                        <IconButton onClick={handleCloseDrawer} className={classes.closeButton}>
                            <FontAwesomeIcon icon={faXmark} fontSize={20} />
                        </IconButton>
                    )}
                </Stack>
                <OrderSummaryContent
                    isRefundOrder={isRefundOrder}
                    isUpdatable={isUpdatable}
                    orderType={orderType}
                    userId={userId}
                    mode={mode}
                />
            </Stack>
        </>
    )
}
